import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { PlanetDossier } from "@/components/PlanetDossier";
import { ProbeSequence } from "@/components/ProbeSequence";
import { useDiscover } from "@/hooks/useDiscover";
import { api, errMsg } from "@/lib/api";

export default function PlanetDetail() {
  const { id } = useParams();
  const location = useLocation();
  const [planet, setPlanet] = useState(null);
  const [error, setError] = useState("");
  const { job, start, dismiss } = useDiscover();
  const reveal = !!location.state?.reveal;

  useEffect(() => {
    setPlanet(null);
    setError("");
    api.get(`/planets/${id}`).then((r) => setPlanet(r.data)).catch((e) => setError(errMsg(e)));
  }, [id]);

  useEffect(() => {
    if (!planet || planet.has_image) return;
    const t = setInterval(() => api.get(`/planets/${id}`).then((r) => { if (r.data.has_image) setPlanet(r.data); }).catch(() => {}), 4000);
    return () => clearInterval(t);
  }, [planet, id]);

  return (
    <div className="relative z-10 min-h-screen" data-testid="planet-detail-page">
      <Header />
      <main className="mx-auto max-w-7xl px-4 sm:px-6 py-10">
        <Link to="/universe" className="label-mono inline-flex items-center gap-2 hover:text-cyan-300 transition-colors mb-8" data-testid="back-to-universe-link">
          <ArrowLeft className="h-3.5 w-3.5" /> Back to sector map
        </Link>
        {error && <p className="glass rounded-xl p-8 text-[#FF5500] font-mono text-sm" data-testid="planet-error">{error}</p>}
        {!planet && !error && <p className="label-mono animate-pulse" data-testid="planet-loading">Decrypting dossier…</p>}
        {planet && <PlanetDossier planet={planet} setPlanet={setPlanet} reveal={reveal} onDiscoverAgain={start} />}
      </main>
      <ProbeSequence job={job} onDismiss={dismiss} onRetry={() => { dismiss(); start(); }} />
    </div>
  );
}
